// userContext/UserContext.js
import React, { createContext, useState, useEffect } from "react";

// Cria o contexto
export const UserContext = createContext();

const defaultOferta = {
  isTestOffer: false,
  subscriptionDays: null,
  accessDurationLabel: "12 meses",
  // null = ainda não sabemos; evita mostrar 2x/cartão antes da API responder
  cardPaymentAllowed: null,
  cardAmount: null,
};

// Cria o Provider para envolver sua aplicação
export const UserProvider = ({ children }) => {
  // Estado para o usuário
  const [user, setUser] = useState(null);
  // Novo estado para o valor do pagamento
  const [valorPagamento, setValorPagamento] = useState(null);
  const [ofertaPagamento, setOfertaPagamento] = useState(defaultOferta);

  // useEffect que busca o valor do pagamento assim que o usuário estiver definido
  useEffect(() => {
    // Verifica se o usuário está definido e possui um ID
    if (user && user.id) {
      fetch(`${process.env.REACT_APP_API_BASE_URL}/payments/consultar-valor/${user.id}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.transaction_amount) {
            setValorPagamento(data.transaction_amount);
            setOfertaPagamento({
              isTestOffer: Boolean(data.is_test_offer),
              subscriptionDays: data.subscription_days_override ?? null,
              accessDurationLabel: data.access_duration_label || "12 meses",
              cardPaymentAllowed: data.card_payment_allowed !== false,
              cardAmount: data.card_transaction_amount ?? null,
            });
          }
        })
        .catch((err) => {
          console.error("Erro ao buscar o valor:", err);
        });
    }
  }, [user]);

  return (
    <UserContext.Provider
      value={{ user, setUser, valorPagamento, ofertaPagamento }}
    >
      {children}
    </UserContext.Provider>
  );
};
